"use client";
import useSWR from "swr";
import { useAuth } from "@/contexts/auth-context";
import { getAdministrationAccess } from "@/lib/organization-api";
export function useOrganizationAccess(offset = 0) {
  const { user, isAuthenticated } = useAuth();
  const result = useSWR(isAuthenticated && user ? ["organization-access", user.id, offset] : null,
    () => getAdministrationAccess(offset), { keepPreviousData: false, revalidateOnMount: true,
      revalidateOnFocus: true, refreshInterval: 60_000, shouldRetryOnError: false });
  return { ...result, current: !result.error ? result.data : undefined };
}
